import { roundToPlaces } from "../../utils/roundToPlaces.js";

export function calculatePriceWithoutTax(priceWithTax: number, taxRate: number): number {
	const taxCoefficient = 1 + taxRate / 100;
	const withoutTax = priceWithTax / taxCoefficient;
	return roundToPlaces(withoutTax, 2);
}
